import { NgModule } from '@angular/core'
import { MenuConditionsPipe } from './menu-conditions.pipe'
import { SchemaFilterPipe } from './schema-filter.pipe'

@NgModule({
    declarations: [
        MenuConditionsPipe,
        SchemaFilterPipe,
    ],
    exports: [
        MenuConditionsPipe,
        SchemaFilterPipe,
    ]
})
export class MainPipesModule {}